import { Link, useParams } from "react-router-dom";

export default function PaymentCancelPage() {
    const { shipmentId } = useParams();

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-100">
            <div className="bg-white p-8 rounded shadow text-center max-w-md">
                <h1 className="text-2xl font-bold text-red-600 mb-3">
                    ❌ Payment cancelled
                </h1>

                <p className="text-gray-600 mb-6">
                    Your payment was not completed.
                    You can try again anytime.
                </p>

                <div className="flex flex-col gap-3">
                    <Link
                        to="/client/orders"
                        className="bg-indigo-600 text-white py-2 rounded hover:bg-indigo-700"
                    >
                        Back to Orders
                    </Link>

                    {shipmentId && (
                        <Link
                            to={`/payment/${shipmentId}`}
                            className="text-blue-600 hover:underline"
                        >
                            Retry payment
                        </Link>
                    )}
                </div>
            </div>
        </div>
    );
}